import AdHeader from '@/components/adHeader';
import {
    getAppointmentDetails,
    getGarageFromPincode,
    getPincodeFromLatitudeLongitude,
    getReviewsCity,
} from '@/components/fakeDoor/api';
import { getGarageId, ROUTEMAP } from '@/components/fakeDoor/constants';
import Footer from '@/components/seoPages/Footer';
import { getEntriesCms } from '@/utils/strapi';
import { useContext, useEffect, useState } from 'react';
import { DeviceContext } from '@/pages/_app';
import MetaTags from '@/components/DefaultMetaTags';
import { CustomerBodyStyle } from './[city]/[garageOrBrand]';
import { GenericLandingPage } from '@/components/seoPages/GenericLandingPage';
import { StaticExploreCta } from '@/components/staticExploreCta/StaticExploreCta';
import { getHeaderString } from '@/utils/common';
import { clearPincodeAndGarageIdFromLocalStorage } from '@/utils/index';
import { getRewardDetailsFromCoupons } from '@/utils/rewards';
import { useDispatch, useSelector } from 'react-redux';
import { API_ROUTES } from '@/constants/apiPaths';
import { loadGrowthbookFeatures, getFeatureValue } from '@/utils/growthbook';
import BottomNavigation from '@/components/BottomNavigation';
import { useShowCtaAfterFold } from '@/hooks/useShowCtaAfterFold';
import {
    selectCardDetails,
    setAppointments,
} from '@/store/modules/appointmentSlice';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_FAKEDOOR_LANDING } from '@/analytics/events';
import useOnce from '@/hooks/useOnce';
import {
    fetchAppointmentDetailsFromOrderId,
    getAllGarageDetails,
    fetchRewardDetails,
    getUserPolicy,
    getCdpData,
    getPincodeByGarageId,
} from '@/utils/api';
import { getGarageCardDetails } from '@/utils/garage';
import { CDPData, IGarageDetails, IPincodeData } from '@/types';
import { generateGarageJsonLd } from '@/config/garageJsonLd.config';
import { AUTH_KEYS, TRACKER_ID } from '@/constants/common';
import { ADSC_BOTTOM_NAV } from '@/constants/featureFlags';
import {
    APPOINTMENT_CARD_TYPE,
    PAGE_TYPE,
    SEO_URL_TYPE,
    USER_POLICY_TYPE,
} from '@/constants/enums';
import {
    RewardConditions,
    FetchRewardResponseDto,
    GarageCardDetails,
} from '@/types';
import {
    LOCAL_STORAGE_KEYS,
    SESSION_STORAGE_KEYS,
} from '@/constants/storageKeys';
import { useRouter } from 'next/router';
import Router from '@/components/common/router';
import { authenticationService } from '@/services/authentication_service';
import RewardGriefity from '@/components/common/rewardGriefity';
import { DEFAULT_REWARD_DESCRIPTION } from '@/constants/index';
import { useAppBarUpdate } from '@/hooks/useAppBarUpdate';
import { LIGHT_THEME_APPBAR_CONFIG } from '@/config/appbarConfig';

function CitySeoPage(props: any) {
    console.log('CitySeoPage props ::', props);
    const router = useRouter();
    const initialPincode = props?.pincode;
    const [pincode, setPincode] = useState<string>(initialPincode);
    const [location, setLocation] = useState<{
        lat: number | null;
        lng: number | null;
    }>({ lat: null, lng: null });

    useAppBarUpdate(LIGHT_THEME_APPBAR_CONFIG);

    useEffect(() => {
        if (props?.garageId) {
            return;
        }

        if (props?.pincode) {
            return;
        }

        if (!props?.isLoggedInServerSide) {
            console.log('User is not logged in');
            return;
        }

        const geolocation = navigator.geolocation;
        if (!geolocation) {
            return;
        }

        if ('permissions' in navigator) {
            navigator.permissions
                .query({ name: 'geolocation' as PermissionName })
                .then((result) => {
                    if (result.state === 'granted') {
                        geolocation.getCurrentPosition(
                            (position: GeolocationPosition) => {
                                const newLocation = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };
                                setLocation(newLocation);
                                console.log('Location:', newLocation);
                            },
                            () => {
                                console.log(
                                    'Error getting geolocation permission'
                                );
                            }
                        );
                    }
                })
                .catch(() => {
                    console.error('Error getting geolocation permission');
                });
        } else {
            geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    const newLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setLocation(newLocation);
                    console.log('Location:', newLocation);
                },
                () => {
                    console.log('Error getting geolocation permission');
                }
            );
        }
    }, [props?.garageId]);

    useEffect(() => {
        if (props?.garageId) {
            return;
        }

        if (location.lat !== null && location.lng !== null) {
            console.log('Location updated:', location);
            (async () => {
                const pincodeResponse = await getPincodeFromLatitudeLongitude({
                    latitude: location.lat!,
                    longitude: location.lng!,
                });
                if (
                    pincodeResponse &&
                    (pincodeResponse.garageId || pincodeResponse.garage_id)
                ) {
                    const garageId = (
                        pincodeResponse.garageId ||
                        pincodeResponse.garage_id ||
                        ''
                    ).toLowerCase();
                    if (garageId && pincodeResponse.pincode) {
                        Router.replace({
                            pathname: router.pathname,
                            query: {
                                ...router.query,
                                pincode: pincodeResponse.pincode,
                                garageId: garageId,
                            },
                        });
                        return;
                    }
                }
                if (pincodeResponse && pincodeResponse.pincode) {
                    setPincode(pincodeResponse.pincode);
                    console.log('Pincode set:', pincodeResponse.pincode);

                    if (
                        !pincodeResponse.garageId &&
                        !pincodeResponse.garage_id
                    ) {
                        const queryParams = new URLSearchParams({
                            pincode: pincodeResponse.pincode,
                        });
                        Router.replace(
                            `${ROUTEMAP.GARAGE_COMING_SOON}?${queryParams.toString()}`
                        );
                    }
                }
            })();
        }
    }, [location, pincode, props?.garageId]);
    const dispatch = useDispatch();
    const isMobileDevice = useContext(DeviceContext)?.isMobile;
    const showCta = useShowCtaAfterFold('CarServices', !props.showHeader);
    const { profileData } = useSelector((state: any) => ({
        profileData: state?.myAccount?.profileData,
    }));
    const cardData = useSelector(selectCardDetails) || {};
    const garageData: IGarageDetails[] = props?.garageDetails;
    const jsonLd = generateGarageJsonLd(
        garageData,
        SEO_URL_TYPE.SERVICE_CENTRE
    );
    const { utm_medium } = router.query;
    // const routerQuery = router.query;
    // const [showRewardGriefity, setShowRewardGriefity] = useState(false);

    // useEffect(() => {
    //     const showReward = sessionStorage.getItem(
    //         SESSION_STORAGE_KEYS.BANNER_SHOWN
    //     );
    //     if (showReward) {
    //         setShowRewardGriefity(true);
    //         sessionStorage.removeItem(SESSION_STORAGE_KEYS.BANNER_SHOWN);
    //     }
    // }, []);

    useEffect(() => {
        if (props?.appointmentData?.garage_id) {
            dispatch(setAppointments(props?.appointmentData));
        }
    }, []);

    useEffect(() => {
        clearPincodeAndGarageIdFromLocalStorage();
        if (utm_medium) {
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.UTM_MEDIUM,
                utm_medium as string
            );
        }
        if (
            props?.garageId &&
            !props?.isMultipleGarage &&
            !props?.appointmentData?.appointment_id
        ) {
            localStorage.setItem(
                LOCAL_STORAGE_KEYS.GARAGE_ID,
                props?.garageId as string
            );
        }
        if (props?.pincode) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.PINCODE, props.pincode);
        }
    }, [
        props.garageId,
        props.pincode,
        props.isMultipleGarage,
        props.appointmentData?.appointment_id,
    ]);

    const { isCouponAvailable, couponCode, offerDetails } =
        getRewardDetailsFromCoupons(props?.rewardDetails?.coupons);

    useOnce(() => {
        viewPageAPI({
            event_name: VIEW_PAGE_FAKEDOOR_LANDING,
            customAttributes: {
                page_type: 'landing_new',
                show_bottom_nav: props.showBottomNav,
                is_coupon_available: isCouponAvailable,
                coupon_code: couponCode,
                offer_details: offerDetails,
            },
            isFakeDoor: true,
        });
    });

    return (
        <>
            <MetaTags
                title={props?.garageSeoCommonsdata?.landingMetaTitle}
                description={
                    props?.garageSeoCommonsdata?.landingMetaDescription
                }
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Corporation',
                        name: 'ACKO Drive',
                        url: 'https://ackodrive.com/',
                        logo: 'https://ackodrive-assets.s3.amazonaws.com/media/Ackodrive_2023_Color.png',
                        contactPoint: {
                            '@type': 'ContactPoint',
                            telephone: '18002662250',
                            contactType: 'customer service',
                            areaServed: 'IN',
                            availableLanguage: ['en', 'Hindi'],
                        },
                        sameAs: [
                            'https://www.facebook.com/ackodrive/',
                            'https://www.instagram.com/ackodrive/',
                            'https://twitter.com/ackodrive',
                        ],
                    }),
                }}
            />
            {jsonLd && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(jsonLd),
                    }}
                />
            )}
            <CustomerBodyStyle isMobile={isMobileDevice} />
            {props.showHeader && (
                <AdHeader
                    hideHamburgerMenu={false}
                    isMobileDevice={true}
                    hideShadow={true}
                />
            )}
            {props?.garageSeoCommonsdata?.ReusableComponents?.map(
                (ReusableComponent: any, index: number) => {
                    return (
                        <section
                            id={ReusableComponent.componentName}
                            key={ReusableComponent.componentName}
                        >
                            <GenericLandingPage
                                ReusableComponent={ReusableComponent}
                                first_name={profileData?.first_name || ''}
                                cardData={cardData}
                                {...props}
                            />
                        </section>
                    );
                }
            )}
            {props.showBottomNav ? (
                <BottomNavigation />
            ) : (
                showCta && (
                    <StaticExploreCta
                        targetId="CarServices"
                        withHeader={props.showHeader}
                        hasCardData={
                            !!cardData && !!Object.keys(cardData).length
                        }
                    />
                )
            )}
            {/* {showRewardGriefity && (
                <RewardGriefity
                    title={''}
                    description={DEFAULT_REWARD_DESCRIPTION}
                    couponCode={''}
                    setShowReward={setShowRewardGriefity}
                    showReward={showRewardGriefity}
                    showCouponCode={false}
                />
            )} */}
            <Footer cities={props?.garageSeoCommonsdata?.liveCities} />
        </>
    );
}

export const getServerSideProps = async (ctx: any) => {
    const req = ctx.req;
    const query = ctx.query;
    const currentHost = req.headers.host;
    const expectedHost = process.env.NEXT_PUBLIC_AD_FRONT_APP_HOST?.replace(
        /^https?:\/\//,
        ''
    ).replace(/\/$/, '');
    let showHeader = false;

    if (currentHost === expectedHost) {
        showHeader = true;
    }
    const userId =
        getHeaderString(req.headers[AUTH_KEYS.X_USER_ID]) ||
        getHeaderString(req.headers[TRACKER_ID]);
    await loadGrowthbookFeatures(userId);
    const showBottomNav = getFeatureValue({ flagName: ADSC_BOTTOM_NAV });

    let garageSeoCommonsdata: any = await getEntriesCms(
        `garage-seo-commons`,
        'live',
        'createdAt',
        999,
        '',
        '',
        '',
        true
    );

    let manualContentId =
        garageSeoCommonsdata?.[0]?.attributes?.manualUrls?.['service-centre'];
    let garageSeoManualdata: any = {};
    if (manualContentId) {
        garageSeoManualdata = await getEntriesCms(
            `garage-seo-manual-contents/${manualContentId}`,
            'live',
            'createdAt',
            999,
            '',
            '',
            '',
            true
        );
    }

    let n = [];
    let u = [...garageSeoCommonsdata?.[0]?.attributes.ReusableComponents];
    n = u.find((x) => x.componentName === 'Faq');
    let tempshowQuestions = Number(n?.showQuestions);
    if (garageSeoManualdata?.attributes?.Faqs) {
        let tempData = garageSeoManualdata?.attributes?.Faqs;
        n = tempData;
        let len = Math.ceil(tempData?.Faqs?.length / tempshowQuestions);
        let rdm = Math.floor(Math.random() * len);
        tempData = {
            ...tempData,
            Faqs: tempData.Faqs.splice(
                rdm * tempshowQuestions,
                tempshowQuestions
            ),
        };
        if (garageSeoManualdata?.attributes) {
            garageSeoManualdata.attributes.Faqs = tempData;
        }
    }

    const currentGarageId = await getGarageId('kudlu-gate');
    let reviewData: any = await getReviewsCity(currentGarageId);
    const garageDetails = await getAllGarageDetails();

    let garageData: any = await getEntriesCms(
        `acko-garages`,
        'live',
        'createdAt',
        999,
        `garageId`,
        '$eq',
        `${currentGarageId}`,
        false,
        ['garageId'],
        [
            'servicing_brands',
            'servicing_brands.company_image_url',
            'garage_review_ratings',
            'garage_review_ratings.reviews',
        ]
    );
    const appointmentData = await fetchAppointmentDetailsFromOrderId(req);
    const userPolicyType = await getUserPolicy(ctx.req);

    let rewardDetails: FetchRewardResponseDto | undefined;
    let cdpData: CDPData | undefined;
    let garageCardDetails: GarageCardDetails[] = [];

    // Get from query params , either garage id or both garage id and pincode will be available
    let garageId = query?.garageId;
    let pincode = query?.pincode;

    //if appointmentData exists
    if (
        appointmentData &&
        appointmentData?.garage_id &&
        appointmentData?.pickup_details?.address?.pincode
    ) {
        garageId = appointmentData?.garage_id;
        pincode = appointmentData?.pickup_details?.address?.pincode;
    }

    //if garageId available and pincode not available
    if (garageId && !pincode) {
        const pincodeResponse = await getPincodeByGarageId(garageId, ctx.req);
        pincode = pincodeResponse?.pincode;
        // garageCardDetails = await getGarageCardDetails(
        //     garageId,
        //     pincode,
        //     ctx.req
        // );
    }

    // if pincode available
    if (pincode) {
        const res = await getGarageFromPincode(pincode);
        if (res?.id !== null) {
            garageId = res?.id;
            // garageCardDetails = await getGarageCardDetails(
            //     garageId,
            //     pincode,
            //     ctx.req
            // );
        }
    }

    //if garage id not available, get from cdp data which will give pincode and garage id(tagger api)
    if (garageId === undefined) {
        cdpData = await getCdpData(ctx.req);
        garageId = cdpData?.garage_id ?? undefined;
        pincode = cdpData?.pincode ?? undefined;
    }

    //if garage id and pincode available, get garage card details
    if (garageId !== undefined && pincode !== undefined) {
        garageCardDetails = await getGarageCardDetails(
            garageId,
            pincode,
            ctx.req
        );
    }

    const data: RewardConditions = {
        garage_id: garageId,
    };

    rewardDetails = await fetchRewardDetails(ctx.req, data);
    const isLoggedInServerSide = authenticationService.isLoggedInServerBrowser(
        ctx.req,
        ctx.res
    );

    const isMultipleGarage = garageCardDetails.length > 1;

    console.log(
        'garageData',
        garageData,
        'garageSeoCommonsdata',
        garageSeoCommonsdata
    );
    return {
        props: {
            garageSeoCommonsdata: garageSeoCommonsdata?.[0]?.attributes || [],
            garageSeoManualdata: garageSeoManualdata?.attributes || {},
            garageData: garageData?.[0]?.attributes || [],
            reviewData: reviewData || {},
            garageDetails: garageDetails || [],
            showHeader: showHeader,
            showBottomNav: showBottomNav,
            appointmentData: appointmentData || {},
            rewardDetails: rewardDetails || {},
            garageId: garageId || null,
            isLoggedInServerSide: isLoggedInServerSide,
            userPolicyType: userPolicyType || {},
            cdpData: cdpData || {},
            garageCardDetails: garageCardDetails || [],
            pincode: pincode || null,
            isMultipleGarage: isMultipleGarage,
            pageType: PAGE_TYPE.LANDING_PAGE,
        },
    };
};

export default CitySeoPage;
